<div class="quiz-container" [class.is-collapsed]="isCollapsed">
  <div class="quiz-header" (click)="toggleCollapse()">
    <div class="header-left">
      <div class="quiz-icon-wrapper">
        <mat-icon>grading</mat-icon>
      </div>
      <div class="header-content">
        <h4 class="quiz-title">{{ currentQuizData.title }}</h4>
        <span class="question-count">{{ currentQuizData.questions.length }} {{ 'Global.Questions' | translate | lowercase }}</span>
      </div>
    </div>
    <div class="header-right">
      <!-- @if (isCollapsed) {
        <button class="start-quiz-pill" (click)="$event.stopPropagation(); toggleCollapse()">
          <span class="pill-icon">▶</span>
          {{ 'Quiz.StartQuiz' | translate }}
        </button>
      } -->
      <mat-icon class="collapse-icon">{{ isCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
    </div>
  </div>

  @if (!isCollapsed) {
    <div class="quiz-body">
      <div class="questions-list">
        @for (question of currentQuizData.questions; track $index; let i = $index) {
          <div class="question-item">
            <div class="question-text">
              <span class="q-number">{{ i + 1 }}</span>
              <p>{{ question.text }}</p>
            </div>

            @if (question.type === 'free-text') {
              <div class="free-text-answer-wrapper">
                @if (!submitted) {
                  <textarea
                    class="free-text-textarea"
                    [placeholder]="('Quiz.TypeYourAnswerPlaceholder' | translate) || 'Type your answer here...'"
                    [(ngModel)]="userAnswers[i]"
                    [disabled]="isEvaluating"
                    rows="3"
                  ></textarea>
                } @else {
                  <div class="free-text-user-answer">
                    <div class="user-answer-header">
                      <strong>{{ ('Quiz.YourAnswer' | translate) || 'Your Answer' }}:</strong>
                    </div>
                    <p class="user-answer-text">{{ userAnswers[i] }}</p>
                  </div>

                  @if (getFeedback(i)) {
                    <div class="evaluation-feedback-card" [class.correct]="isCorrect(i)" [class.incorrect]="!isCorrect(i)">
                      <div class="feedback-header">
                        <mat-icon class="feedback-icon">
                          {{ isCorrect(i) ? 'check_small' : 'close_small' }}
                        </mat-icon>
                        <span class="feedback-status">
                          {{ isCorrect(i) ? ('Quiz.Correct' | translate) || 'Correct' : ('Quiz.Incorrect' | translate) || 'Incorrect' }}
                        </span>
                      </div>
                      <p class="feedback-text">{{ getFeedback(i) }}</p>
                    </div>
                  }
                }
              </div>
            } @else {
              <div class="options-list">
                @for (option of question.options; track $index; let j = $index) {
                  <div class="option-item" [class]="getOptionClass(i, j)" (click)="isMultiChoice(question) ? toggleOption(i, j) : !submitted && (userAnswers[i] = j)">
                    <div class="radio-indicator">
                      @if (submitted) {
                        @if (isSelected(i, j)) {
                          @if (isOptionCorrect(question, j)) {
                            <mat-icon class="status-icon correct">check_small</mat-icon>
                          } @else {
                            <mat-icon class="status-icon incorrect">close_small</mat-icon>
                          }
                        } @else if (isOptionCorrect(question, j)) {
                          <mat-icon class="status-icon correct">check_small</mat-icon>
                        } @else {
                          @if (isMultiChoice(question)) {
                            <ui-checkbox [disabled]="true"></ui-checkbox>
                          } @else {
                            <div class="radio-circle"></div>
                          }
                        }
                      } @else {
                        @if (isMultiChoice(question)) {
                          <ui-checkbox [checked]="isSelected(i, j)" (checkedChange)="toggleOption(i, j)"></ui-checkbox>
                        } @else {
                          <div class="radio-circle" [class.selected]="isSelected(i, j)"></div>
                        }
                      }
                    </div>

                    <span class="option-label">{{ option }}</span>
                  </div>
                }
              </div>
            }

            @if (submitted && question.explanation) {
              <div class="explanation-box">
                <mat-icon>tooltip_2</mat-icon>
                <div>
                  <p>
                    <strong>{{ getExplanationLabel(question) }}:</strong>
                    {{ question.explanation }}
                  </p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="quiz-footer">
      @if (!submitted) {
        <button mat-flat-button color="primary" class="full-width-btn" [disabled]="!isAllAnswered" [class.is-evaluating]="isEvaluating" (click)="submit()">
          @if (isEvaluating) {
            <div class="btn-loading-content">
              <mat-spinner diameter="18" class="btn-spinner"></mat-spinner>
              <span>{{ ('Quiz.Evaluating' | translate) || 'Evaluating with AI...' }}</span>
            </div>
          } @else {
            {{ 'Global.VerifyAnswers' | translate }}
          }
        </button>
      } @else {
        <div class="results-row">
          <div class="score-ring-wrapper">
            <svg class="score-ring" viewBox="0 0 36 36">
              <circle class="ring-bg" cx="18" cy="18" r="15.5" fill="none" stroke-width="3" />
              <circle
                class="ring-value"
                cx="18"
                cy="18"
                r="15.5"
                fill="none"
                stroke-width="3"
                stroke-linecap="round"
                [attr.stroke-dasharray]="(percentage * 97.4) / 100 + ' ' + 97.4"
                [class.high]="percentage >= 70"
                [class.mid]="percentage >= 40 && percentage < 70"
                [class.low]="percentage < 40"
              />
            </svg>
            <span class="ring-label" [class.high]="percentage >= 70" [class.mid]="percentage >= 40 && percentage < 70" [class.low]="percentage < 40">{{ percentage }}%</span>
          </div>
          <span class="score-fraction">{{ score }}/{{ currentQuizData.questions.length }}</span>
          <button matButton btnType="neutral" class="ml-auto" (click)="reset()" [disabled]="isEvaluating">
            <mat-icon class="me-2">restart_alt</mat-icon>
            {{ 'Global.Restart' | translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
